const ONBOARDING_V2_ELIGIBLE_KEY = 'onboarding_v2_eligible';

export function setV2Eligible(): void {
  try {
    localStorage.setItem(ONBOARDING_V2_ELIGIBLE_KEY, '1');
  } catch {
    // localStorage unavailable (SSR, iframe sandbox, etc.)
  }
}

export function consumeIsV2Eligible(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const value = localStorage.getItem(ONBOARDING_V2_ELIGIBLE_KEY);
    return value === '1';
  } catch {
    return false;
  }
}
